<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 24 24" fill="none">
    <path d="M17.3 2.89999V11.4477M4.69995 2.89999V18.1953C4.69995 18.9242 5.52114 19.3508 6.11748 18.9317L9.96486 16.2275C10.586 15.791 11.414 15.791 12.035 16.2275" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17 15.2V18.8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15.2 17H18.8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7.625 2.89999H14.375M9.875 9.42499H12.125M8.75 6.27499H13.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    <circle cx="17" cy="17" r="4.8" stroke="currentColor" stroke-width="1.5"/>
  </svg>
</template>

<script>
export default {
  name: 'CreateSavedFilterIcon',
  props: {
    width: {
      type: Number,
      default: 24
    },
    height: {
      type: Number,
      default: 24
    }
  }
}
</script>

<style scoped></style>